import { fallbackMenuPath } from '@/utils/menuFallbackPath'

export type AppConfig = {
    apiPrefix: string;
    authenticatedEntryPath: string;
    authenticatedEntryPath1: string;
    authenticatedEntryPath2: string;
    unAuthenticatedEntryPath: string;
    locale: string;
    accessTokenPersistStrategy: 'localStorage' | 'sessionStorage' | 'cookies';
    enableMock: boolean;
    loginpath: string;
};

const menu = localStorage.getItem('userMenuList');
const storedMenuList = menu ? JSON.parse(menu) : [];

const allUrlPaths: string[] = storedMenuList.flatMap((main: any) => {
    const urls: string[] = [];

    if (main.urlPath) {
        urls.push(main.urlPath);
    }

    if (Array.isArray(main.menuList)) {
        main.menuList.forEach((sub: any) => {
            if (sub.urlPath) {
                urls.push(sub.urlPath);
            }
        });
    }

    return urls;
});

// ✅ Use first path or fallback
const loginpath: string =
    allUrlPaths[0] || fallbackMenuPath(storedMenuList) || '';





const appConfig: AppConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath1: '/basicdetails?mc=2001',
    authenticatedEntryPath: loginpath, // ✅ now it's a string
    authenticatedEntryPath2: '/change-otp',
    // Where logged-out users land: opening the app, protected pages, and after
    // logout (AllRoutes, ProtectedRoute, AuthProvider). Must stay '/sign-in-v2'
    // - it was switched to '/home' once (commit 8e33daa) and the landing page
    // changed with it.
    unAuthenticatedEntryPath: '/sign-in-v2',
    locale: 'en',
    accessTokenPersistStrategy: 'cookies',
    enableMock: true,
    loginpath,
};



export default appConfig;
